import React, { memo, useState } from 'react';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import PropTypes from 'prop-types';
import { Collapse } from 'reactstrap';

const Accordion = ({ title, children }) => {
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(!open);
  };

  return (
    <>
      <button
        type="button"
        onClick={handleClick}
        className="list-group-item border-0 align-items-center list-group-item-action d-flex justify-content-between mb-2"
      >
        <span>{title}</span>
        {open ? <ExpandLess /> : <ExpandMore />}
      </button>
      <Collapse isOpen={open} className="my-2">
        {children}
      </Collapse>
    </>
  );
};

Accordion.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default memo(Accordion);
